import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getIsZendeskInitedSelector } from '../zendeskSelectors';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import useZendeskWebWidgetInstance from "./useZendeskWebWidgetInstance";

function useZendeskLocale() {
    const isWebWidgetInited = useSelector(getIsZendeskInitedSelector);
    const zendeskWebWidgetInstance = useZendeskWebWidgetInstance();
    const { locale } = useLangContext();

    useEffect(() => {
        if (!isWebWidgetInited) {
            return;
        }
        if (locale) {
            zendeskWebWidgetInstance.setLocale(locale);
        }
    }, [isWebWidgetInited, locale, zendeskWebWidgetInstance]);
}

export default useZendeskLocale;
